import { RESET_FORM } from '../actionTypes';
import { resetPasswordUserActions } from '../reducer';

export default () => resetPasswordUserActions[RESET_FORM]();
